export default __webpack_public_path__ + "f2f3014c12415047147c0bff305623c7.gif";